// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3DNDc","Label":"BuildControl_Label__1qh4_","Decrease":"BuildControl_Decrease__F-0BF","Increase":"BuildControl_Increase__1makZ"};